import {Pipe, PipeTransform} from '@angular/core';
import {CompetitorResultsDetail, MeasurementPrecisionTypes, MeasurementTypes} from '@model';
import {TotalTimePipe} from "./total-time-pipe";
import {milisecondsToPrecision, removeLeadingZeros} from "@utility";

@Pipe({
    name: 'resultsGapTime',
    standalone: false
})
export class ResultsGapTimePipe implements PipeTransform {

  transform(competitorResultsDetail: CompetitorResultsDetail | undefined, firstCompetitorResultsDetail: CompetitorResultsDetail | undefined, measurementType: MeasurementTypes | undefined, measurementPrecisionType: MeasurementPrecisionTypes | undefined): string {
    measurementPrecisionType = measurementPrecisionType ?? MeasurementPrecisionTypes.SECONDS;

    const precomputedGap = competitorResultsDetail?.display_gap_time;

    if (precomputedGap !== undefined && precomputedGap !== null) {
      return removeLeadingZeros(milisecondsToPrecision(Number(precomputedGap), measurementPrecisionType).replace(".000", ""));
    }

    const totalTime = TotalTimePipe.getTotalTime(competitorResultsDetail, measurementType);
    const firstCompetitorTotalTime = TotalTimePipe.getTotalTime(firstCompetitorResultsDetail, measurementType);
    if (totalTime && firstCompetitorTotalTime && totalTime !== '-' && firstCompetitorTotalTime !== '-' && totalTime >= firstCompetitorTotalTime) {
      return removeLeadingZeros(this.calculateGap(firstCompetitorTotalTime, totalTime, measurementPrecisionType).replace(".000", ""));
    } else {
      return '-';
    }
  }

  calculateGap(firstCompetitorTotalTime:string, totalTime:string, measurementPrecisionType: MeasurementPrecisionTypes) {
    try {
      const firstCompetitorTotalTimeInMilliseconds = this.timeStringToMilliseconds(firstCompetitorTotalTime);
      const totalTimeInMilliseconds = this.timeStringToMilliseconds(totalTime);
      const gapInMilliseconds = totalTimeInMilliseconds - firstCompetitorTotalTimeInMilliseconds;
      return milisecondsToPrecision(gapInMilliseconds, measurementPrecisionType);
    } catch (e) {
      console.log("error calculating gap time" + e);
      return '-';
    }
  }

  timeStringToMilliseconds(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':');
    const [secs, millis] = seconds.split('.').map(Number);
    return (Number(hours) * 3600000) + (Number(minutes) * 60000) + (secs * 1000) + millis;
  }
}


